import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import Scrollspy from 'react-scrollspy'


const Menu = (props) => (
    <nav id="menu">
        <div className="inner">

             <h1>Menu </h1>
            <ul className="links">
            <Scrollspy items={ ['banner', 'bannermission', 'banner_what_we_do','banner_what_end_to_end','blocs_banner_our_domains','blocs_banner_getin_touch','blocs_banner_imprint'] } currentClassName="is-current">
            <li><a href="#banner" onClick={props.onToggleMenu}>Banner</a></li>
            <li><a href="#bannermission"onClick={props.onToggleMenu}>OUR MISSION</a></li>
            <li><a href="#banner_what_we_do" onClick={props.onToggleMenu}>WHAT WE DO</a></li>
            <li><a href="#banner_what_end_to_end" onClick={props.onToggleMenu}>END2END DIGITALIZATION DELIVERY</a></li>
            <li><a href="#blocs_banner_our_domains" onClick={props.onToggleMenu}>OUR DOMAINS</a></li>
            <li><a href="#blocs_banner_getin_touch" onClick={props.onToggleMenu}>GET IN TOUCH</a></li>
            <li><a href="#blocs_banner_imprint" onClick={props.onToggleMenu}>IMPRINT</a></li>
           
                {/* <li><Link onClick={props.onToggleMenu} to="/">Header Title</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Section Title</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Section SubTitle</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Main Title</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Sub Title</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Tile Title</Link></li>
                <li><Link onClick={props.onToggleMenu} to="/">Tile SubTitle</Link></li> */}
                 </Scrollspy>
            </ul>

            <p>  We fundamentally change the way businesses and industries operate, creating measurable value for our clients, end users and society.</p>
            {/* <ul className="actions vertical">
                <li><a href="#" className="button special fit">Get Started</a></li>
                <li><a href="#" className="button fit">Log In</a></li>
            </ul> */}
        </div>
        <a className="close" onClick={props.onToggleMenu} href="javascript:;">Close</a>
    </nav>
)

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Menu
